export enum ConditionType {
    REQUIRED = 'required',
    CONDITIONALLY_REQUIRED = 'conditionally_required',
    RECOMMENDED = 'recommended',
    OPTIONAL = 'optional'
}

export enum TaxonomyConditionType {
    REQUIRED = 'required',
    USUALLY_REQUIRED = 'usually required',
    RECOMMENDED = 'recommended',
    SOMETIMES_REQUIRED = 'sometimes required',
    OPTIONAL = 'optional',
    CONDITIONAL = 'conditional'
}
